import { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";

export default function IncomeExpenses() {
    const { transactions } = useContext(GlobalContext);

    const incomes = transactions.filter((positive) => positive.amount > 0).reduce((acc, cur) => (acc += cur.amount), 0).toFixed(2);
    const expense = transactions.filter((expen) => expen.amount < 0).reduce((acc, cur) => (acc += cur.amount), 0).toFixed(2);
    const hour = new Date().getHours();
    const minute = new Date().getMinutes();
    console.log(hour, minute);

    return (
        <div className="inc-exp-container">
            <div className="income-box">
                <h4>Income</h4>
                <p className="grn-clr">+${Math.abs(incomes)}</p>
            </div>
            <div className="expense-box">
                <h4>Expense</h4>
                <p className="red-clr">-${Math.abs(expense)}</p>
            </div>
        </div>
    )
}
